<template>
  <div>
    <h5>Up Coming Movies</h5>
    <div>
      <div >
        <div class="movie-card">
          <img src="@/assets/img/poster1.png" class="w-100">
          <div class="p-3">
            <div class="movie-name">Lego Movie {{ item.name }}</div>
            <ul class="list-inline">
              <li class="list-inline-item">PG 13</li>
              <li class="list-inline-item">Documentary</li>
              <li class="list-inline-item">English</li>
              <li class="list-inline-item" v-for="(_item, _index) in 2" :key="_index">2D</li>
            </ul>
            <hr>
            <div class="d-flex">
              <div class="mr-2">08 Feb, 2019</div>
              <div>2 hrs 00 min</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/UpComingMovies.vue